import { ConfirmationPopperType } from './ConfirmationPopper';
import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const confirmationPopperBody = css`
  display: flex;
  width: 230px;
  z-index: 120000;
`;

export const titleIcon = css`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const closeTitleIcon = (popperType: ConfirmationPopperType) => css`
  width: 20px;
  height: 20px;
  margin-right: 5px;
  color: ${
    popperType === ConfirmationPopperType.DEFAULT
      ? colors.error.default
      : colors.warning.default
  };
`;

export const closeText = css`
  max-width: 300px;
  margin-bottom: 10px;
`;

export const closeActions = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
`;
